import { render, staticRenderFns } from "./StepEight.vue?vue&type=template&id=74a987a3&"
import script from "./StepEight.vue?vue&type=script&lang=js&"
export * from "./StepEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports